import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'az',
  months: [
    'yanvar',
    'fevral',
    'mart',
    'aprel',
    'may',
    'iyun',
    'iyul',
    'avqust',
    'sentyabr',
    'oktyabr',
    'noyabr',
    'dekabr',
  ],
  monthsShort: ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avq', 'sen', 'okt', 'noy', 'dek'],
  weekdays: ['bazar', 'bazar ertəsi', 'çərşənbə axşamı', 'çərşənbə', 'cümə axşamı', 'cümə', 'şənbə'],
  weekdaysMin: ['7', '1', '2', '3', '4', '5', '6'],
  weekdaysShort: ['B.', 'B.e.', 'Ç.a.', 'Ç.', 'C.a.', 'C.', 'Ş.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'D MMMM YYYY, dddd HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'D MMM YYYY, ddd h:mm A',
    'llll-Y': 'D MMM, ddd h:mm A',
    'll-Y+w': 'D MMM, ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'AM', pm: 'PM', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s il öncə', other: '%s il öncə' },
    M: { one: '%s ay öncə', other: '%s ay öncə' },
    w: { one: '%s həftə öncə', other: '%s həftə öncə' },
    d: { one: '%s gün öncə', other: '%s gün öncə' },
    h: { one: '%s saat öncə', other: '%s saat öncə' },
    m: { one: '%s dəq öncə', other: '%s dəq öncə' },
    s: { one: '%s san öncə', other: '%s san öncə' },
  },
  future: {
    y: { one: '%s il sonra', other: '%s il sonra' },
    M: { one: '%s ay sonra', other: '%s ay sonra' },
    w: { one: '%s həftə sonra', other: '%s həftə sonra' },
    d: { one: '%s gün sonra', other: '%s gün sonra' },
    h: { one: '%s saat sonra', other: '%s saat sonra' },
    m: { one: '%s dəq sonra', other: '%s dəq sonra' },
    s: { one: '%s san sonra', other: '%s san sonra' },
  },
  pastLong: {
    y: { one: '%s il öncə', other: '%s il öncə' },
    M: { one: '%s ay öncə', other: '%s ay öncə' },
    w: { one: '%s həftə öncə', other: '%s həftə öncə' },
    d: { one: '%s gün öncə', other: '%s gün öncə' },
    h: { one: '%s saat öncə', other: '%s saat öncə' },
    m: { one: '%s dəqiqə öncə', other: '%s dəqiqə öncə' },
    s: { one: '%s saniyə öncə', other: '%s saniyə öncə' },
  },
  futureLong: {
    y: { one: '%s il sonra', other: '%s il sonra' },
    M: { one: '%s ay sonra', other: '%s ay sonra' },
    w: { one: '%s həftə sonra', other: '%s həftə sonra' },
    d: { one: '%s gün sonra', other: '%s gün sonra' },
    h: { one: '%s saat sonra', other: '%s saat sonra' },
    m: { one: '%s dəqiqə sonra', other: '%s dəqiqə sonra' },
    s: { one: '%s saniyə sonra', other: '%s saniyə sonra' },
  },
  abbr: {
    y: { one: '%s il', other: '%s il' },
    M: { one: '%s ay', other: '%s ay' },
    w: { one: '%s həftə', other: '%s həftə' },
    d: { one: '%s gün', other: '%s gün' },
    h: { one: '%s saat', other: '%s saat' },
    m: { one: '%s dəq', other: '%s dəq' },
    s: { one: '%s san', other: '%s san' },
  },
  full: {
    y: { one: '%s il', other: '%s il' },
    M: { one: '%s ay', other: '%s ay' },
    w: { one: '%s həftə', other: '%s həftə' },
    d: { one: '%s gün', other: '%s gün' },
    h: { one: '%s saat', other: '%s saat' },
    m: { one: '%s dəqiqə', other: '%s dəqiqə' },
    s: { one: '%s saniyə', other: '%s saniyə' },
  },
  justNow: 'indi',
  yesterday: 'dünən',
  today: 'bu gün',
  tomorrow: 'sabah',
  weekStart: 1,
  timeRange: '%$1s–%$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'D MMM YYYY, ddd', end: 'D MMM YYYY, ddd' },
    'Y-1': { start: 'D MMM YYYY, ddd', end: 'D MMM, ddd' },
    M: { start: 'D MMM, ddd', end: 'D MMM, ddd' },
    D: { start: 'D MMM, ddd', end: 'D MMM, ddd' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'az';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'AM' : 'AM';
    } else {
      return isLowerCase ? 'PM' : 'PM';
    }
  },
};
